import * as React from 'react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';

export default function LocationTable({ rows, onLocationClick }) {
    const columns = [
        {
            field: 'name',
            headerName: 'Name',
            flex: 1,
            renderCell: (params) => (
                <span
                    style={{ color: '#1976d2', cursor: 'pointer', textDecoration: 'underline' }}
                    onClick={() => onLocationClick(params.row.latitude, params.row.longitude)}
                >
                    {params.value}
                </span>
            ),
        },
        { field: 'country', headerName: 'Country', flex: 1 },
        { field: 'admin1', headerName: 'Admin1', flex: 1 },
        { field: 'admin2', headerName: 'Admin2', flex: 1 },
        { field: 'latitude', headerName: 'Latitude', flex: 1 },
        { field: 'longitude', headerName: 'Longitude', flex: 1 },
        {
            field: 'elevation',
            headerName: 'Elevation',
            flex: 1,
            valueFormatter: (params) => {
                if (!params || params.value == null) return 'N/A';
                return `${params.value}m`;
            },
        },
        {
            field: 'population',
            headerName: 'Population',
            flex: 1,
            valueFormatter: (params) => {
                if (!params || params.value == null) return 'N/A';
                return params.value.toLocaleString();
            },
        },
        { field: 'feature_code', headerName: 'Feature Code', flex: 1 },
        { field: 'timezone', headerName: 'Timezone', flex: 1 },
    ];

    return (
        <Paper elevation={3} sx={{ mt: 4 }}>
            <DataGrid
                disableSelectionOnClick
                rows={rows}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[10, 25, 50]}
                getRowId={(row) => row.id}
                components={{ Toolbar: GridToolbar }}
                sx={{
                    '& .MuiDataGrid-columnHeaders': { backgroundColor: '#f5f5f5' },
                    '& .MuiDataGrid-row:hover': { backgroundColor: '#e3f2fd' },
                }}
            />
        </Paper>
    );
}